import { Link2, ChevronRight } from "lucide-react";

const COLOR = { rosso: "#D92D20", giallo: "#D97706", verde: "#16A34A", grigio: "#525252" };

export function FilieraPanel({ bridge }) {
  const anelli = bridge?.anelli || [];
  const weeks = (bridge?.weeks || []).slice(-6);
  return (
    <section className="border border-[#262626] rounded-xl bg-[#111111] p-6 space-y-6" data-testid="strategy-filiera">
      <div>
        <h2 className="font-display font-bold text-white text-lg flex items-center gap-2"><Link2 size={18} style={{ color: "#D97706" }} /> La filiera — «ogni anello rotto è fatturato perso»</h2>
        <p className="text-xs text-neutral-500 mt-1">Virale → attenzione → follower → consapevolezza → DM → lead → cliente. Semafori calcolati dai tuoi dati Instagram.</p>
      </div>

      {anelli.length > 0 && (
        <div className="flex flex-wrap items-stretch gap-2" data-testid="strategy-anelli">
          {anelli.map((a, i) => (
            <div key={a.n} className="flex items-stretch gap-2">
              <div className="rounded-lg border border-[#262626] p-3 w-[150px]" data-testid={`strategy-anello-${a.n}`}>
                <div className="flex items-center gap-2 mb-1">
                  <span className="w-2.5 h-2.5 rounded-full shrink-0" style={{ background: COLOR[a.stato] || COLOR.grigio, boxShadow: `0 0 10px ${COLOR[a.stato] || COLOR.grigio}` }} />
                  <p className="text-xs font-bold text-white">{String(a.n).padStart(2, "0")} {a.nome}</p>
                </div>
                <p className="text-[0.68rem] text-neutral-500 leading-snug">{a.desc}</p>
                <p className="text-[0.68rem] text-neutral-300 mt-2 leading-snug">{a.valore}</p>
              </div>
              {i < anelli.length - 1 && <ChevronRight size={14} className="text-neutral-700 self-center" />}
            </div>
          ))}
        </div>
      )}

      {weeks.length > 0 && (
        <div className="overflow-x-auto" data-testid="strategy-bridge-table">
          <p className="text-xs uppercase tracking-wide text-neutral-500 mb-2">Metriche del ponte (formule Mik) — per settimana</p>
          <table className="w-full text-sm">
            <thead>
              <tr className="text-[0.65rem] uppercase tracking-wide text-neutral-500 border-b border-[#262626]">
                <th className="text-left py-2 font-medium">Settimana</th>
                <th className="text-right py-2 font-medium">Reach</th>
                <th className="text-right py-2 font-medium">+Follower</th>
                <th className="text-right py-2 font-medium">Condivisioni</th>
                <th className="text-right py-2 font-medium">Follower / 1.000 reach</th>
                <th className="text-right py-2 font-medium">Compound (foll./cond.)</th>
              </tr>
            </thead>
            <tbody>
              {weeks.map((w) => (
                <tr key={w.week_start} className="border-b border-[#1c1c1c]" data-testid={`strategy-bridge-row-${w.week_start}`}>
                  <td className="py-2 text-neutral-300">{w.week_start.slice(8)}/{w.week_start.slice(5, 7)} → {w.week_end.slice(8)}/{w.week_end.slice(5, 7)}{w.current && <span className="ml-2 text-[0.6rem] uppercase text-amber-500">in corso</span>}</td>
                  <td className="py-2 text-right text-neutral-300">{w.reach.toLocaleString("it-IT")}</td>
                  <td className="py-2 text-right text-white font-semibold">+{w.follower_gain}</td>
                  <td className="py-2 text-right text-neutral-300">{w.shares}</td>
                  <td className="py-2 text-right font-semibold" style={{ color: w.follower_per_1000_reach == null ? "#525252" : w.follower_per_1000_reach < 0.8 ? "#D92D20" : w.follower_per_1000_reach < 1.2 ? "#D97706" : "#16A34A" }}>{w.follower_per_1000_reach ?? "–"}</td>
                  <td className="py-2 text-right text-neutral-300">{w.compound ?? "–"}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <p className="text-[0.68rem] text-neutral-600 mt-2">Conversione profilo e conversione follower non ancora disponibili: le visite al profilo non vengono salvate giorno per giorno (limite API Meta, da sistemare in Andamento).</p>
        </div>
      )}
    </section>
  );
}
